import { Component, OnInit, NgModule } from '@angular/core';
import { Factsheet } from './factsheet';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import {Observable, of} from 'rxjs';
import {delay, map} from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Injectable({ providedIn: 'root'})

@Component({
    selector: 'app-add-fact-sheet',
    templateUrl: './add-fact-sheet.component.html',
    styleUrls: ['./add-fact-sheet.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class AddFactSheetComponent implements OnInit {
  url: string;
  addFactSheetEvent: FormGroup;
  id: any;
  numb: any;
  fileurls = [];
  dtColumns = [];
  fileSize: string;
  fileName: string;
  pageurl: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  editable: boolean;
  loading: boolean;
  Status: number;
  Msg: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.loading = false;
    this.Msg = "";
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
      // Set Validation for Fact Sheet Form
    this.addFactSheetEvent = this.formBuilder.group({
        EventDate: ['', Validators.required], eventDescription: ['', Validators.required], browseFiles: [''] });
  }

  get f() { return this.addFactSheetEvent.controls; }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
    // For Get Fact Sheet Files in Base64 format
onSelectFile(event) {
  this.fileurls = [];
  this.fileName = '';
  this.fileSize = '';
  if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        let reader = new FileReader();
        reader.onload = ( event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
  }
}
onFactSheetSubmit(FactSheetFormData) {
  if (this.addFactSheetEvent.invalid) {
    this.addFactSheetEvent.markAllAsTouched();
    return;
  }
  if (FactSheetFormData.eventDescription != "") {
    if (this.addFactSheetEvent.invalid) { return; }
    this.numb = 1;
    this.loading= true;
    this.Msg = "";
    let fsheet: Factsheet = {
     id: this.numb,
     fileSize: this.fileSize,
     fileBase: this.fileurls,
     fileName: this.fileName,
     fDate: FactSheetFormData.EventDate,
     description: FactSheetFormData.eventDescription,
     noticeID: this.id,
     recAddUser: this.numb,
     contextID: this.numb
    };
    this.http.post(this.url + 'Notice/saveFactSheet', fsheet) .subscribe( (data) => {
      this.Msg = "";
      this.loading= false;
           if (data == null) {
            this.alertService.error("Fact Sheet Not Submitted",true);
           } else {
            this.alertService.success("Fact Sheet Submitted",this.options);
             this.addFactSheetEvent.patchValue({ EventDate: "", eventDescription: "" });
           }
          }
        );
} else { this.alertService.warn('Add Event Desciption',this.options); }
}
}
